module.exports = __webpack_public_path__ + "static/media/medicare.107e52de.jpg";